import { Eye } from "lucide-react";
import { SectionCard } from "../../../../Component/AgentComponents/SectionCard";
import RefreshButton from "../../../../Component/Common/RefreshButton";
import SimpleTable from "../../../../Component/Common/SimpleTable";
import RegularLoader from "../../../../Component/Loader/RegularLoader";
import BlueButton from "../../../../Component/Common/BlueButton";

export default function ClaimsTable({
  showOnlyActive,
  claimsLoading,
  claimRows,
  claimsPage,
  claimsTotalPages,
  setClaimsPage,
  setSelectedClaim,
  fetchClaims,
  claimCards,
  setApprovingClaim,
  setShowApproveModal,
  setAssigningClaim,
  setShowAssignModal,
}) {
  if (showOnlyActive) return null;

  const hasData = Array.isArray(claimRows) && claimRows.length > 0;

  return (
    <SectionCard title="Claims – Approvals, Rejections & Reasons">
      <div className="flex justify-end mb-3">
        <RefreshButton onClick={fetchClaims} />
      </div>

      {/* LOADING */}
      {claimsLoading && <RegularLoader />}

      {/* NO DATA */}
      {!claimsLoading && !hasData && (
        <div className="flex flex-col items-center justify-center py-10 text-center">
          <p className="text-sm font-semibold text-slate-600">
            No claims found
          </p>
          <p className="mt-1 text-xs text-slate-500">
            Claims will appear here once they are raised.
          </p>
        </div>
      )}

      {/* DATA */}
      {!claimsLoading && hasData && (
        <>
          {/* DESKTOP TABLE */}
          <div className="hidden md:block">
            <SimpleTable
              headers={[
                "Claim",
                "Retailer / Customer",
                "Issue",
                "Amounts",
                "Status",
              ]}
              rows={claimRows}
              currentPage={claimsPage}
              totalPages={claimsTotalPages}
              onPageChange={setClaimsPage}
              showSrNo
              onRowClick={(raw) => {
                setSelectedClaim({
                  id: raw.id,
                  RawID: raw.id,
                  device: `${raw.device?.product_name || "—"} · ${
                    raw.device?.imei1 || "—"
                  }`,
                  retailer:
                    raw.customer?.retailer?.business_name || "—",
                  customer: raw.customer?.name || "—",
                  approvedAmount: Number(raw.estimate_amount || 0),
                  payableAmount: Number(raw.payable_amount || 0),
                  status: raw.status,
                  reason: raw.reason || "",
                  paymentLink: raw.payment_link || "",
                  lastUpdated: raw.updated_at?.slice(0, 10),
                  raisedBy: raw.raised_by || "—",
                });
              }}
              renderActions={(row) => {
                const status = String(row.status || "")
                  .toLowerCase()
                  .replaceAll(" ", "_");

                const showAssign = status === "approved";

                return (
                  <div
                    className={`flex items-center gap-1 w-full ${
                      showAssign ? "justify-start" : "justify-center"
                    }`}
                  >
                    {/* VIEW */}
                    <BlueButton
                      onClick={(e) => {
                        e.stopPropagation();
                        setApprovingClaim(row);
                        setShowApproveModal(true);
                      }}
                      // className="text-[10px] px-2 py-0.5 rounded-lg border bg-slate-50 flex items-center gap-1"
                    >
                      {/* <Eye className="w-4 h-4" /> */}
                      View
                    </BlueButton>

                    {/* ASSIGN (ONLY WHEN APPROVED) */}
                    {showAssign && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setAssigningClaim(row);
                          setShowAssignModal(true);
                        }}
                        className="text-[10px] px-2 py-0.5 rounded-lg border bg-blue-50 text-blue-600"
                      >
                        Assign
                      </button>
                    )}
                  </div>
                );
              }}
            />
          </div>

          {/* MOBILE CARDS */}
<div className="md:hidden space-y-3">
  {claimRows.map((row) => {
    const raw = row.raw;
    const status = String(raw.status || "").toLowerCase();
    const isPending = status.includes("pending");

    return (
      <div
        key={raw.id}
        className="bg-white rounded-2xl shadow-sm border-l-4 border-orange-400 p-4"
      >
        {/* TOP SECTION */}
        <div className="flex justify-between items-start gap-2">
          <div>
            <h3 className="text-sm font-semibold text-slate-800">
              {raw.device?.product_name || "Device Claim"}
            </h3>

            <p className="text-xs text-slate-500 mt-1">
              Claim ID:{" "}
              <span className="font-medium">
                {raw.claim_no || raw.id}
              </span>
            </p>

            <p className="text-xs text-slate-500">
              Customer:{" "}
              <span className="font-medium">
                {raw.customer?.name || "—"}
              </span>
            </p>
          </div>

          {/* STATUS BADGE */}
          <span
            className={`text-[10px] px-2 py-1 rounded-full font-medium capitalize
              ${
                isPending
                  ? "bg-orange-100 text-orange-600"
                  : "bg-slate-100 text-slate-600"
              }`}
          >
            {raw.status}
          </span>
        </div>

        {/* INFO GRID */}
        <div className="grid grid-cols-2 gap-3 mt-4 text-xs">
          <div>
            <p className="text-slate-400">IMEI</p>
            <p className="font-medium text-slate-700">
              {raw.device?.imei1 || "—"}
            </p>
          </div>

          <div>
            <p className="text-slate-400">Claim Date</p>
            <p className="font-medium text-slate-700">
              {raw.created_at?.slice(0, 10) || "—"}
            </p>
          </div>
        </div>

        {/* MORE LINK */}
        <div className="flex justify-end mt-2">
          <button
            onClick={() => {
              setSelectedClaim(raw);
            }}
            className="text-xs text-blue-600 font-medium"
          >
            More →
          </button>
        </div>

        {/* VIEW BUTTON */}
        <button
          onClick={() => {
            setApprovingClaim(raw);
            setShowApproveModal(true);
          }}
          className="mt-3 w-full rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 py-2 text-white text-sm font-semibold"
        >
          View Claim
        </button>
      </div>
    );
  })}
</div>

        </>
      )}
    </SectionCard>
  );
}



// import { Eye } from "lucide-react";
// import { SectionCard } from "../../../../Component/AgentComponents/SectionCard";
// import RefreshButton from "../../../../Component/Common/RefreshButton";
// import SimpleTable from "../../../../Component/Common/SimpleTable";
// import RegularLoader from "../../../../Component/Loader/RegularLoader";

// export default function ClaimsTable({
//   showOnlyActive,
//   claimsLoading,
//   claimRows,
//   claimsPage,
//   claimsTotalPages,
//   setClaimsPage,
//   setSelectedClaim,
//   fetchClaims,
//   claimCards,
//   setApprovingClaim,
//   setShowApproveModal,
//   setAssigningClaim,
//   setShowAssignModal,
// }) {
//   if (showOnlyActive) return null;

//   return (
//     <SectionCard title="Claims – Approvals, Rejections & Reasons">
//       <div className="flex justify-end">
//         <RefreshButton onClick={fetchClaims} />
//       </div>

//       {claimsLoading ? (
//         <RegularLoader />
//       ) : (
//         <>
//           <div className="hidden md:block">
//             <SimpleTable
//               headers={["Claim", "Retailer / Customer", "Issue", "Amounts", "Status"]}
//               rows={claimRows}
//               currentPage={claimsPage}
//               totalPages={claimsTotalPages}
//               onPageChange={setClaimsPage}
//               showSrNo
//               onRowClick={(raw) => {
//                 setSelectedClaim({
//                     id: `CLM-${raw.id}`,
//                     RawID: raw.id,
//                     device: `${raw.device?.product_name || "—"} · ${raw.device?.imei1 || "—"}`,
//                     retailer: raw.customer?.retailer?.business_name || "—",
//                     customer: raw.customer?.name || "—",
//                     approvedAmount: Number(raw.estimate_amount || 0),
//                     payableAmount: Number(raw.payable_amount || 0),
//                     status: raw.status,
//                     reason: raw.reason || "",
//                     paymentLink: raw.payment_link || "",
//                     lastUpdated: raw.updated_at?.slice(0, 10),
//                     raisedBy: raw.raised_by || "—",
//                 });
//                 }}

//                 renderActions={(row) => {
//                 const status = String(row.status || "")
//                     .toLowerCase()
//                     .replaceAll(" ", "_");

//                 const showAssign = status === "approved";

//                 return (
//                     <div
//                     className={`flex items-center gap-1 w-full ${
//                         showAssign ? "justify-start" : "justify-center"
//                     }`}
//                     >
//                     {/* VIEW */}
//                     <button
//                         onClick={(e) => {
//                         e.stopPropagation();
//                         setApprovingClaim(row);
//                         setShowApproveModal(true);
//                         }}
//                         className="text-[10px] px-2 py-0.5 rounded-lg border bg-slate-50 flex items-center gap-1"
//                     >
//                         <Eye className="w-4 h-4" />
//                         View
//                     </button>

//                     {/* ASSIGN → ONLY WHEN APPROVED */}
//                     {showAssign && (
//                         <button
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             setAssigningClaim(row);
//                             setShowAssignModal(true);
//                         }}
//                         className="text-[10px] px-2 py-0.5 rounded-lg border bg-blue-50 text-blue-600"
//                         >
//                         Assign
//                         </button>
//                     )}
//                     </div>
//                 );
//                 }}

//             />
//           </div>

//           <div className="md:hidden space-y-2">{claimCards}</div>
//         </>
//       )}
//     </SectionCard>
//   );
// }



// import { Eye } from "lucide-react";

// import SimpleTable from "../../../../Component/Common/SimpleTable";
// import Badge from "../../../../Component/Common/Badge";
// import { formatCurrency } from "../../../../Component/AdminComponents/formatCurrency";

// export default function ClaimsTable({
//   claims,
//   loading,
//   page,
//   totalPages,
//   onPageChange,
//   onRowSelect,
//   onView,
// }) {
//   const rows = claims.map((c) => ({
//     raw: c,
//     cells: [
//       { title: `CLM-${c.id}`, sub: `WAR-${c.w_device_id}` },
//       { title: c.customer?.name || "—" },
//       { title: c.issue_description },
//       {
//         title: `₹ ${formatCurrency(c.estimate_amount)}`,
//         sub: `Payable: ₹ ${formatCurrency(c.estimate_amount)}`,
//       },
//       <Badge label={c.status} color="yellow" />,
//     ],
//   }));

//   return (
//     <SimpleTable
//       headers={["Claim", "Customer", "Issue", "Amount", "Status"]}
//       rows={rows}
//       currentPage={page}
//       totalPages={totalPages}
//       onPageChange={onPageChange}
//       showSrNo
//       onRowClick={onRowSelect}
//       renderActions={(row) => (
//         <button
//           onClick={() => onView(row)}
//           className="px-2 py-1 text-xs border rounded-lg"
//         >
//           <Eye className="w-4 h-4" />
//         </button>
//       )}
//     />
//   );
// }
